export const CART_ADD_ITEM = 'CART_ADD_ITEM';
export const CART_REMOVE_ITEM = 'CART_REMOVE_ITEM';
export const CART_REMOVE_ALL_ITEMS = 'CART_REMOVE_ALL_ITEMS';
export const CART_UPDATE_QUANTITIES = 'CART_UPDATE_QUANTITIES';
export const CART_UPDATE_BALANCE = 'CART_UPDATE_BALANCE';
export const CART_UPDATE_LOGIN = 'CART_UPDATE_LOGIN';
export const CART_UPDATE_DEPOSIT = 'CART_UPDATE_DEPOSIT';
